import React from 'react';
import { CheckCircle2Icon, HomeIcon, MailIcon, MessageSquareIcon, UserPlusIcon } from 'lucide-react';
import { activity, type ActivityItem } from '../data/mockData';
const iconByKey: Record<ActivityItem['icon'], React.ElementType> = {
  home: HomeIcon,
  user: UserPlusIcon,
  message: MessageSquareIcon,
  mail: MailIcon,
  check: CheckCircle2Icon
};
export function ActivityFeed() {
  return <section className="flex h-full flex-col rounded-xl border border-gray-200 bg-white" aria-labelledby="activity-heading" data-id="element-18" data-mp="1999mvfajg4xa">
      <div className="flex items-center justify-between border-b border-gray-200 px-4 py-3.5" data-id="element-19" data-mp="1e5hxcfdsj9y4">
        <h2 id="activity-heading" className="text-[14px] font-semibold text-ink" data-id="element-20" data-mp="1iz2w49n7k7yd">
          Activity
        </h2>
        <span className="rounded-full bg-gray-100 px-2 py-0.5 text-[10px] font-medium uppercase tracking-wide text-gray-500" data-id="element-21" data-mp="1nz76dhxiw6g5">
          Live
        </span>
      </div>
      <ul className="scrollbar-thin max-h-[420px] flex-1 divide-y divide-gray-100 overflow-y-auto" data-id="element-22" data-mp="1wylu49mb22wy">
        {activity.map(item => {
        const Icon = iconByKey[item.icon];
        return <li key={item.id} className="flex gap-3 px-4 py-3" data-id="element-23" data-mp="16zxs0g3hwoj0">
              <span className="mt-0.5 flex h-6 w-6 shrink-0 items-center justify-center rounded-md bg-gray-100 text-gray-500" data-id="element-24" data-mp="121mgm0xjy5yo">
                <Icon className="h-3.5 w-3.5" aria-hidden="true" data-id="element-25" data-mp="x4mj4eerqbj6" />
              </span>
              <span className="min-w-0" data-id="element-26" data-mp="1uq1u2j11cg7w">
                <span className="block text-[12.5px] leading-snug text-gray-600" data-id="element-27" data-mp="1uswe49g4zz0s">
                  <span className="font-semibold text-ink" data-id="element-28" data-mp="1pss6l8x7iemp">{item.emphasis}</span>{' '}
                  {item.text}
                </span>
                <span className="mt-1 block text-[11px] text-gray-400" data-id="element-29" data-mp="1g2gqko090ezg">
                  {item.time}
                </span>
              </span>
            </li>;
      })}
      </ul>
    </section>;
}